<template>
  <div @click="eventData" v-html="htmlDatas"></div>
</template>
<script>
export default {
  name: 'editorial-rich-text',
  props: {
    datas: {
      type: String,
      required: true,
    },
    datas1: {
      type: String,
      required: true,
    },
    datas2: {
      type: String,
      required: true,
    },
  },
  data() {
    return { htmlDatas: this.datas, defaultClassName: 'datalayer-class' };
  },
  created() {
    this.htmlDatas = this.datas.replaceAll('<a', '<a class="datalayer-class cc-fi-button"');
  },
  methods: {
    eventData(e) {
      // NOSONAR
      let path = [];
      const parentClasses = [];
      const innerLinkText = [];
      const innerLinkHtml = [];
      const hrefValue = [];
      if (e.path == undefined) {
        path = e.composedPath && e.composedPath();
      } else {
        path = e.path;
      }
      for (const element of path) {
        parentClasses.push(element.className);
        innerLinkText.push(element.innerText);
        if (element.innerHTML != '' && element.innerHTML != undefined) {
          const matchEl = element.innerHTML.includes('datalayer-class cc-fi-button');
          if (matchEl) {
            innerLinkHtml.push(element.innerHTML);
          } else {
            innerLinkHtml.push(element.href);
          }
        }
      }
      const classLists = parentClasses.includes('datalayer-class cc-fi-button');
      if (innerLinkHtml[0] != '' && innerLinkHtml[0] != undefined) {
        const xHrefVal = innerLinkHtml[0].split('/');
        const arrXhref = xHrefVal.slice(3, xHrefVal.length);
        hrefValue.push(arrXhref.join('/'));
      } else if (innerLinkHtml[0] == undefined) {
        const xHrefVal2 = innerLinkHtml[1].split('/');
        const arrXhref2 = xHrefVal2.slice(3, xHrefVal2.length);
        hrefValue.push(arrXhref2.join('/'));
      }

      if (classLists) {
        if (Object.keys(hrefValue).length > 0 && this.datas1 != 'salon locator') {
          dataLayer.push({
            event: 'uaevent',
            ecommerce: 'undefined',
            eventCategory: this.datas1.toLowerCase().trim(),
            eventAction: `select::${this.datas2.toLowerCase().trim()}`,
            eventLabel:
              innerLinkText[1].toLowerCase().trim() + '::' + hrefValue[0].toLowerCase().trim(),
            event_name: 'body_button_click',
            module_name: this.datas2.toLowerCase().trim(),
            cta_name: innerLinkText[1].toLowerCase().trim(),
            link_url: hrefValue[0].toLowerCase().trim(),
          });
        } else {
          /// Country Flag datalayer
          dataLayer.push({
            event: 'uaevent',
            event_name: 'body_button_click',
            ecommerce: 'undefined',
            eventCategory: this.datas1.toLowerCase().trim(),
            eventAction: 'select::languages selector',
            eventLabel: innerLinkText[1].toLowerCase().trim(),
            module_name: 'languages selector',
          });
        }
      }
    },
  },
};
</script>
